import React from 'react';
import { useForm } from 'react-hook-form';

import { CancelButton, FormButton } from '../../../../../components/Button';
import CustomDropdown from '../../../../../components/DropDown';
import { FormFieldset, Textarea } from '../../../../../components/Form';
import Loader from '../../../../../components/Loader';
import { priority, status } from '../../__Test__/MockTasksheet';
import { IAddTaskSheet, ITaskSheetId } from '../../Tasksheet.props';
import useEditTaskSheet from './useEditTasksheet';

const EditTaskSheet: React.FC<ITaskSheetId> = ({ taskSheetId, setMethod }) => {
  const {
    loading,
    formData,
    handleChange,
    handleSubmit,
    handlePriorityChange,
    handleStatusChange,
    handleUserChange,
    handleProjectChange,
    user,
    project,
    setFormData,
  } = useEditTaskSheet(taskSheetId, setMethod);

  console.log("formData", formData);
  
  const { handleSubmit: useFormSubmit } = useForm<IAddTaskSheet>();

  return (
    <div className="flex flex-col items-center w-full h-full pr-8 pl-6">
      <div className="bg-white shadow-md rounded-lg pt-6 pb-6 w-full">
        <div className="border-b-2 w-[100%]">
          <h1 className="text-3xl mb-2 text-fontBlack ml-5">Edit TaskSheet</h1>
        </div>
        {loading && <Loader />}
        <form
          onSubmit={useFormSubmit(handleSubmit)}
          className="space-y-6 p-6 h-[75vh] overflow-y-scroll"
        >
          <FormFieldset Ftitle="Personal Details">
            <div className="grid grid-cols-4 gap-6 m-4">
              <CustomDropdown
                label="Assigned To:"
                options={user}
                defaultOptionId={formData.assignedTo}
                setDefaultOptionId={handleUserChange}
                displayProperty="name"
                value={formData.assignedTo}
                style="w-full"
              />
              <CustomDropdown
                label="Project:"
                options={project}
                defaultOptionId={formData.projectId}
                setDefaultOptionId={handleProjectChange}
                displayProperty="name"
                value={formData.projectId}
                style="w-full"
              />
              <CustomDropdown
                label="Priority:"
                options={priority}
                defaultOptionId={formData.priority}
                setDefaultOptionId={handlePriorityChange}
                displayProperty="name"
                value={formData.priority}
                style="w-full"
              />
              <CustomDropdown
                label="Status:"
                options={status}
                defaultOptionId={formData.status}
                setDefaultOptionId={handleStatusChange}
                displayProperty="name"
                value={formData.status}
                style="w-full"
              />
            </div>
            <div className="grid grid-cols-3 gap-6 m-4">
              <Textarea
                name="description"
                label="Description"
                value={formData.description}
                onChange={handleChange}
              />
              <div>
                <label className="text-fontBlack text-xs mb-2 flex">
                  Due Date:
                </label>
                <input
                  type="date"
                  name="dueDate"
                  className={`appearance-none border h-14 rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline border-border`}
                  value={
                    formData.dueDate
                      ? new Date(formData.dueDate).toISOString().split("T")[0]
                      : ""
                  }
                  onChange={(e) => {
                    handleChange(e);
                    setFormData({ ...formData, dueDate: e.target.value });
                  }}
                />
              </div>
            </div>
          </FormFieldset>
          <div className="flex justify-center mt-6 ml-2 gap-3">
            <CancelButton
              className="py-2 px-4 h-[56px] w-[200.5px]"
              onClick={() => setMethod?.()}
              children="Cancel"
              type="button"
            />
            <FormButton
              className="py-2 px-4 h-[56px] w-[200.5px]"
              type="submit"
              children="UPDATE"
            />
          </div>
        </form>
      </div>
    </div>
  );
};

export default EditTaskSheet;